import { ChangeDetectorRef, Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { PrestamosModel } from './prestamos.model';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { PrestamosService } from './prestamos.service';
import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { SharedService } from '../../../shared/services/shared.service';
import { PrestamosDialogImportAccount } from './prestamos-dialog-importAccount.component';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-prestamos-form',
    templateUrl: './prestamos-form.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})
export class PrestamosFormComponent implements OnInit {

  @Input() prestamos: PrestamosModel;
  @Output() onSave = new EventEmitter<any>();

  //AccountMovementes Import data
  flagImport: boolean = false;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //----------------------------------

  public bankAccounts: BankAccountModel[] = [];

  public loading = false;
  public ready = false;



  constructor(
    public snackBar: MatSnackBar,
    public prestamosService: PrestamosService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<PrestamosFormComponent>,
    private bankAccountService: BankAccountService,
    private sharedService: SharedService,
    private masterService: MasterService,
    private router: Router
  ) { }

  public ngOnInit(): void {

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      });

    if (this.data != null) {
      this.flagImport = this.data.flagImport;
      this.type = this.data.type;
      this.movement = this.data.movement;
      this.movement.type = this.type;
      this.prestamos.manualMovement = this.movement;
      this.prestamos.importeInicial = this.movement.amount * -1;
      this.prestamos.fechaConstitucion = this.movement.date;
      this.prestamos.numero = this.movement.reference;
      this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
        this.prestamos.manualMovement.accountNumber = response;
      })
    }
    this.ready = true;
  }

  close(){
    this.router.navigate(['/finance/loans/banksloans']);
  }

  closeDialog() {
    this.dialogRef.close(this.saved);
  }

  public save(): void {
    const missing: string[] = [];

    if (this.prestamos.duracion == null || this.prestamos.duracion === 0) missing.push('Duración');
    if (this.prestamos.numero == null || String(this.prestamos.numero).trim() === '') missing.push('Número de préstamo');
    if (this.prestamos.entidad == null || String(this.prestamos.entidad).trim() === '') missing.push('Entidad prestamista');
    if (this.prestamos.importeInicial == null) missing.push('Importe inicial');
    if (this.prestamos.importePendiente == null) missing.push('Importe pendiente');
    if (this.prestamos.fechaConstitucion == null) missing.push('Fecha de constitución');
    if (this.prestamos.plazo == null) missing.push('Plazo');
    if (this.prestamos.fechaFinalizacion == null) missing.push('Fecha de finalización');
    if (this.prestamos.tipoInteres == null) missing.push('Tipo de interés');
    if (this.prestamos.carencia == null) missing.push('Carencia');
    if (this.prestamos.tipoLiquidaciones == null || this.prestamos.tipoLiquidaciones === 0) missing.push('Tipo de liquidaciones');
    if (this.prestamos.bankAccountsUid == null || this.prestamos.bankAccountsUid === consts.EMPTY_GUID) missing.push('Cuenta de adeudo');

    if (missing.length) {
      this.loading = false;
      this.displayInfo('Revisa los campos obligatorios: ' + missing.join(', '));
      return;
    }

    this.loading = true;
    this.setDefaultsValues();

    if (this.data != null) {
      this.prestamosService.add(this.prestamos)
          .then(response => {
            this.saved = true;

          },
            error => {
              //Si venimos de importar, y ya existe el prestamo, preguntamos si queremos actualizar
              //el prestamo ya existente
              if (error.error['message'].includes("ya se encuentra registrado") && this.data != null) {
                this.dialog.open(PrestamosDialogImportAccount, {
                  width: '20%',
                  //height: '40%',
                  data: {
                    dataImport: this.prestamos,
                  }
                }).afterClosed().subscribe(result => this.closeDialog())
              } else {
                this.displayInfo(error.error['message']);
              }
            })
    } else {
      this.onSave.emit(this.prestamos);
    }
    this.loading = false;
  }

  public setDefaultsValues(): void {
    // Valores por defecto en los campos que no sean requeridos
  }

  public setTipoDeLiquidacionesOptions(value: number) {
    this.prestamos.tipoLiquidaciones = value;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
